module.exports = __webpack_public_path__ + "img/leaves-home-2x.646aa1b0.png";